module.exports = __webpack_public_path__ + "static/img/30019 (1).31ec055.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30019 (1).webp
// module id = dOXJ
// module chunks = 14